import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getContenaireById, updateContenaire } from '../../../api/redux/slices/SuperAdmin';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showToast } from '../../../components/modal';

const UpdateContenaire = ({ modalOpen, setModalOpen, lineIndice, onSuccess }) => {
    const dispatch = useDispatch();
    const token = localStorage.getItem('accesstoken');
    const [isFocus, setIsFocus] = useState(false);
    const [loading, setLoading] = useState(false);

    const [values, setValues] = useState({
        nom: '',
        volume: '',
    });

    // Load existing data when modal opens
    useEffect(() => {
        if (!lineIndice || !modalOpen) return;

        setLoading(true);
        dispatch(getContenaireById({ token, id: lineIndice }))
            .unwrap()
            .then((res) => {
                setValues({
                    nom: res.data.nom || '',
                    volume: res.data.volume || '',
                });
            })
            .catch(() => {
                showToast('Erreur lors du chargement', 'error');
            })
            .finally(() => setLoading(false));
    }, [lineIndice, modalOpen, dispatch, token]);

    const handleUpdate = (e) => {
        e.preventDefault();

        if (!values.nom.trim()) {
            showToast('Veuillez remplir le nom du contenaire', 'warn');
            return;
        }

        if (!values.volume || parseFloat(values.volume) <= 0) {
            showToast('Veuillez entrer un volume valide', 'warn');
            return;
        }

        const data = {
            nom: values.nom.trim(),
            volume: parseFloat(values.volume),
        };

        setLoading(true);
        dispatch(updateContenaire({ token, id: lineIndice, data }))
            .unwrap()
            .then(() => {
                toast.success('Contenaire mis à jour', {
                    position: 'top-center',
                    autoClose: 2000,
                });
                setIsFocus(false);
                setModalOpen(false);
                onSuccess?.(); // ← triggers fetchList() in parent
            })
            .catch((err) => {
                toast.error(err?.error || err?.message || 'Erreur lors de la mise à jour', {
                    position: 'top-center',
                    autoClose: 2000,
                });
            })
            .finally(() => setLoading(false));
    };

    const handleCancel = (e) => {
        e.preventDefault();
        setIsFocus(false);
        setModalOpen(false);
    };

    return (
        <div className={'modalcontainer ' + (modalOpen ? 'open' : '')}>
            <div className={'modal ' + (modalOpen ? 'active' : '')}>
                {loading ? (
                    <div style={{ textAlign: 'center', padding: '2rem' }}>Chargement...</div>
                ) : (
                    <form onSubmit={handleUpdate}>
                        <div className='label-input'>
                            <label>
                                Nom du contenaire <span style={{ color: '#e74c3c' }}>*</span>
                            </label>
                            <input
                                type='text'
                                placeholder='Nom'
                                value={values.nom}
                                onChange={(e) => {
                                    setValues({ ...values, nom: e.target.value });
                                    setIsFocus(true);
                                }}
                                required
                            />
                        </div>
                        <div className='label-input'>
                            <label>
                                Volume (m³) <span style={{ color: '#e74c3c' }}>*</span>
                            </label>
                            <input
                                type='number'
                                step='0.01'
                                min='0'
                                placeholder='Volume en m³'
                                value={values.volume}
                                onChange={(e) => {
                                    setValues({ ...values, volume: e.target.value });
                                    setIsFocus(true);
                                }}
                                required
                            />
                        </div>
                        <div className='submit-btns'>
                            <div className='add-btns'>
                                <button
                                    className={isFocus ? 'button-nature' : 'button-nature-inactive'}
                                    onClick={handleCancel}
                                    disabled={loading}
                                >
                                    Annuler
                                </button>
                                <button
                                    className={isFocus ? 'button-primary' : 'button-primary-inactive'}
                                    type='submit'
                                    disabled={loading}
                                >
                                    {loading ? 'Modification...' : 'Modifier'}
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default UpdateContenaire;